export default __webpack_public_path__ + "static/media/Material Handling Bins.25a3452f.jpg";